<template>
    <div :class="['basic-dialog', { hidden: hidden }]" :style="{ '--duration': `${duration}s` }">
        <div class="dialog-box">
            <div class="dialog-box_header">
                <slot name="header"></slot>
            </div>

            <div class="dialog-box_content">
                <slot></slot>
            </div>

            <div class="dialog-box_footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BasicDialog",
    props: {
        duration: {
            type: Number,
            default: 0.22,
        },
    },
    data() {
        return {
            hidden: false,
        };
    },
    methods: {
        hiddenDialog() {
            this.hidden = true;
        },
    },
};
</script>

<style scoped lang="scss">
.basic-dialog {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    overflow: hidden;
    animation: bg var(--duration) linear;

    &.hidden {
        background: rgba(0, 0, 0, 0);
        transition: background var(--duration) linear;

        .dialog-box {
            transform: translate(-50%, -50%) scale(0.7);
            opacity: 0;
            transition: transform var(--duration) linear, opacity var(--duration) linear;
        }
    }

    .dialog-box {
        // min-height: 300px;
        background-color: #ffffff;
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 12px;
        transform: translate(-50%, -50%) scale(1);
        width: 80%;

        animation: show var(--duration) linear;

        &_content {
            // padding: 12px;
        }
    }

    @keyframes bg {
        from {
            background-color: rgba(0, 0, 0, 0);
        }

        to {
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    @keyframes show {
        from {
            transform: translate(-50%, -50%) scale(0.7);
            opacity: 0;
        }

        to {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
    }
}
</style>
